// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"9293558a","162":"610d86b2","359":"0f7c5bfd","453":"795674ee","779":"a363436d"}[chunkId] + ".chunk.js";
};